// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/conti-analitici?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, codice, descrizione, natura, attivo, livello, divisioneId, figli }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/divisioni-analitiche?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, codice, descrizione, attivo }] }'
  },
  {
    method: 'POST',
    endpoint: '/api/movimenti-conto-analitico/bulk',
    requestBody: '{ societaId, data, descrizione, competenzaDal, competenzaAl, voci: [{ contoAnaliticoId, importo }] }',
    response: '{ success: true, data: { creati } }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
